/**
 * Kiruna Tours category document navigation.
 *
 * Category landing pages are prerendered as static HTML.
 * React Router must not render the legacy Tours.jsx
 * component when visitors navigate to these pages.
 *
 * Only seven known category routes are intercepted.
 * Normal React navigation remains active elsewhere.
 */

(function enableCategoryDocumentNavigation() {
  if (
    typeof window === "undefined" ||
    typeof document === "undefined"
  ) {
    return;
  }

  const categoryPaths = new Set([
    "/tours/northern-lights/",
    "/tours/dog-sledding/",
    "/tours/snowmobile/",
    "/tours/reindeer/",
    "/tours/snowshoe/",
    "/tours/arctic-dining/",
    "/tours/abisko/",
  ]);

  const isCategory = (url) =>
    url.origin === window.location.origin &&
    categoryPaths.has(
      url.pathname.replace(/\/+$/, "") + "/"
    );

  document.addEventListener(
    "click",
    (event) => {
      // Preserve normal browser interactions.
      if (
        event.defaultPrevented ||
        event.button !== 0 ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey
      ) {
        return;
      }

      const anchor =
        event.target?.closest?.("a[href]");

      if (!anchor) {
        return;
      }

      // Preserve downloads and new-tab links.
      if (anchor.hasAttribute("download")) {
        return;
      }

      if (
        anchor.target &&
        anchor.target !== "_self"
      ) {
        return;
      }

      const href = anchor.getAttribute("href");

      if (!href || href.startsWith("#")) {
        return;
      }

      let url;

      try {
        url = new URL(
          href,
          window.location.href
        );
      } catch (_error) {
        return;
      }

      if (!isCategory(url)) {
        return;
      }

      // Prevent React Router's SPA transition.
      event.preventDefault();
      event.stopImmediatePropagation();

      // Load the actual prerendered HTML document.
      window.location.assign(url.href);
    },
    true
  );

  /**
   * Browser history may contain a category URL
   * previously visited through React Router.
   *
   * Reload its static document when revisiting.
   */
  window.addEventListener("popstate", () => {
    const url = new URL(
      window.location.href
    );

    if (isCategory(url)) {
      window.location.replace(url.href);
    }
  });
})();
